import ScriptLoader from '../Core/ScriptLoader';
import Url from '../Core/Url/Url';
import { isArray } from 'util';

export default class Hotjar {
    constructor() {
        getUrl = getUrl.bind(this);
        

        this.options = {
            hotjarId: window.config.Statics.hotjarId,
            sv: window.config.Statics.hotjarSV,
            triggerRecording: window.config.Statics.hotjarRecordingTrigger,
            triggerPoll: window.config.Statics.hotjarPoll
        };

        if (!this.options.hotjarId) throw Error('Id de Hotjar no definido (hotjarId)');

        this.scriptLoader = new ScriptLoader({
            src: getUrl(),
            inHead: true,
            defer: false          
        });


    }



    Load() {
        const sv = this.options.sv || 6;
        window.hj = window.hj || function () {
            (window.hj.q = window.hj.q || []).push(arguments);
        };
        window._hjSettings = { hjid: this.options.hotjarId, hjsv: sv };

        this.scriptLoader.Load()
            .then(() => {
            });
    }

    triggerRecording() {
        if (window.hj) {
            const { triggerRecording } = this.options;
            window.hj('trigger',triggerRecording);

        }
    }

    tagRecording(tag) {
        if (!isArray(tag)) {
            tag = [tag];
        }
        if (window.hj) {
            window.hj('tagRecording', tag);
        }
    }

    startPoll() {
        if (window.hj) {
            const { triggerPoll } = this.options;
            window.hj('trigger', triggerPoll);
        }
    }
}

var getUrl = function () {
    const sv = this.options.sv || 6;
    return Url.FromProtocol('https:', `static.hotjar.com/c/hotjar-${this.options.hotjarId}.js?sv=${sv}`);
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Hotjar.js